import styled from 'styled-components'
import { COLOR } from 'src/service/constant/color'
import {customMedia} from "src/styles/common/common";


const TextAreaFormWrap = styled.div`
  > div {
    display: flex;
    justify-content: space-between;

    > p {
      margin: 0 0 12px 0;
      font-family: NotoSansBold, sans-serif;
      font-size: 18px;
      line-height: 26px;
    }

    > span {
      font-size: 16px;
      line-height: 23px;
      font-family: NotoSansRegular, sans-serif;
    }

    .err {
      color: ${COLOR.red};
    }

    .default {
      color: black;
    }

    .complete {
      color: ${COLOR.green};
    }
  }
  ${customMedia.lessThan('tablet')`
    >div{
      >p{
        font-size: 16px;
        line-height: 23px;
      }
     >span{
       font-size: 14px;
       line-height: 20px;
      }
 `}
    
`
const TextAreaCustom = styled.textarea`
  width: 100%;
  height: 374px;
  border: 1px solid ${COLOR.blueGray2};
  border-radius: 10px;
  resize: none;
  padding: 16px 20px;
  font-size: 18px;
  line-height: 26px;
  color: ${COLOR.black};
  font-family: NotoSansRegular, sans-serif;

  &:focus {
    outline: none !important;
    border-color: ${COLOR.point1};
  }

  &::placeholder {
    color: ${COLOR.blueGray3};
  }

  ${customMedia.lessThan('tablet')`
    height: 264px;
    padding: 16px 18px;
    font-size: 16px;
    line-height: 23px;
 `}

`

export { TextAreaFormWrap, TextAreaCustom }
